import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import moment from "moment";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";

import Paper from "@material-ui/core/Paper";
import CountUp from "react-countup";

import Colors from "../../constants/Colors";

import "moment/locale/fr";
import StressIcon from "./StressIcon";
import PeopleImpactIcon from "./PeopleImpactIcon";
import IconStatRow from "./IconStatRow";
import TimeSavedIcon from "./TimeSavedIcon";
import PublicSpeakingDoneIcon from "./PublicSpeakingDoneIcon";

moment.locale("fr");

const getStats = allActions => {
  const result = {
    peopleImpacted: 0,
    timeSaved: 0,
    publicSpeakingDone: 0
  };
  allActions.forEach(action => {
    // timeSaved
    if (action.action === "5bb1fa3922871c0022251f4d") {
      result.timeSaved += 4.5;
    } else if (action.action === "5b967034030fd9002244d9a5") {
      result.timeSaved += 3.5;
    } else if (action.action === "5b967033030fd9002244d9a2") {
      result.timeSaved += 2;
    } else if (action.action === "5bc3a84355dfa700224dc282") {
      result.timeSaved += 3;
    }

    // publicSpeakingDone
    switch (action.category) {
      case "leadership":
        result.publicSpeakingDone += 0.6;
        break;
      case "teamCohesion":
        result.publicSpeakingDone += 1;
        break;
      case "proactivity":
        result.publicSpeakingDone += 0.3;
        break;
      case "publicSpeaking":
        result.publicSpeakingDone += 0.8;
        break;
      default:
        result.publicSpeakingDone += 0.5;
        break;
    }

    // peopleImpacted
  });
  result.peopleImpacted = allActions.length * 3.8;
  result.peopleImpacted = result.peopleImpacted.toFixed(0);
  result.publicSpeakingDone = result.publicSpeakingDone.toFixed(0);
  result.timeSaved = ((result.timeSaved * 15) / 60).toFixed(2);
  return result;
};

const styles = theme => ({
  main: {
    // backgroundColor: "#FAFAFA",
    backgroundColor: "#fff",
    flex: 1,
    paddingRight: "5%",
    paddingLeft: "5%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center"
  },
  leftSection: {
    display: "flex",
    flex: 1,
    height: 250,
    marginRight: "5%",
    alignItems: "center",
    justifyContent: "space-between"
  },
  rightSection: {
    flex: 3,
    display: "flex",
    height: 250,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around"
  },
  companyLogo: {
    width: "40%"
  },
  accent: {
    color: "#6198DE"
  },
  rightTitle: {
    fontWeight: 500,
    marginBottom: 5
  },
  bold: {
    fontWeight: 500
  },
  totalDone: {
    color: "#fff",
    fontWeight: 500
  },
  actionLegend: {
    color: "#fff"
  },
  circle: {
    width: 200,
    height: 200,
    borderRadius: 100,
    webkitBoxShadow: "0px 0px 15px 2px rgba(66,80,251,1)",
    mozBoxShadow: "0px 0px 15px 2px rgba(66,80,251,1)",
    boxShadow: "0px 0px 15px 2px rgba(66,80,251,1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Colors.main
  },
  rightBox: {
    webkitBoxShadow: "0px 0px 4px 1px #D8D8D8",
    mozBoxShadow: "0px 0px 4px 1px #D8D8D8",
    boxShadow: "0px 0px 4px 1px #D8D8D8",
    marginTop: 10,
    marginBottom: 10,
    borderRadius: 10,
    // height: 200,
    width: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  catchPhrase: {
    color: Colors.text,
    marginLeft: 20,
    marginRight: 20,
    marginTop: 10,
    marginBottom: 10,
    fontSize: "1.25rem",
    // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    // lineHeight: 1.6,
    letterSpacing: "0.0075em"
  },
  statDiv: {
    width: "100%",
    alignItems: "center",
    justifyContent: "flex-start",
    display: "flex",
    flexDirection: "row"
  },
  round: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 15,
    padding: 10,
    borderRadius: "50%",
    backgroundColor: Colors.pink,
    webkitBoxShadow: `0px 0px 15px 2px ${Colors.pink}`,
    mozBoxShadow: `0px 0px 15px 2px ${Colors.pink}`,
    boxShadow: `0px 0px 15px 2px ${Colors.pink}`
  },
  equal: {
    fontWeight: 600,
    fontSize: 30,
    alignSelf: "center",
    verticalAlign: "center",
    marginRight: "5%"
  }
});

const isNumber = n => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

class TotalDoneActionsSection extends PureComponent {
  state = {
    peopleImpacted: 0,
    timeSaved: 0,
    publicSpeakingDone: 0
  };

  componentDidMount = () => {
    // this.props.getActionListRequest();
    // setTimeout(() => {
    //   this.setState({ data: this.props.weeklyData });
    // }, 300);
  };

  onChangeClient = event => {
    this.props.changeCreateField({ name: event.target.value });
  };

  onChangeEmail = event => {
    this.props.changeCreateField({ owner: event.target.value });
  };

  onChangeDomain = event => {
    this.props.changeCreateField({ domain: event.target.value });
  };

  onSubmit = () => {
    this.props.createClientRequest({
      name: this.props.name,
      owner: this.props.owner,
      domain: this.props.domain
    });
  };

  getStats = allActions => {
    const result = {
      peopleImpacted: 0,
      timeSaved: 0,
      publicSpeakingDone: 0
    };
    allActions.forEach(action => {
      // timeSaved
      if (action.action === "5bb1fa3922871c0022251f4d") {
        result.timeSaved += 4.5;
      } else if (action.action === "5b967034030fd9002244d9a5") {
        result.timeSaved += 3.5;
      } else if (action.action === "5b967033030fd9002244d9a2") {
        result.timeSaved += 2;
      } else if (action.action === "5bc3a84355dfa700224dc282") {
        result.timeSaved += 3;
      }

      // publicSpeakingDone
      switch (action.category) {
        case "leadership":
          result.publicSpeakingDone += 0.6;
          break;
        case "teamCohesion":
          result.publicSpeakingDone += 1;
          break;
        case "proactivity":
          result.publicSpeakingDone += 0.3;
          break;
        case "publicSpeaking":
          result.publicSpeakingDone += 0.8;
          break;
        default:
          result.publicSpeakingDone += 0.5;
          break;
      }

      // peopleImpacted
    });
    result.peopleImpacted = this.props.allActions.length * 3.8;
    result.peopleImpacted = result.peopleImpacted.toFixed(0);
    result.publicSpeakingDone = result.publicSpeakingDone.toFixed(0);
    result.timeSaved = ((result.timeSaved * 15) / 60).toFixed(2);
    return result;
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.main}>
        <div className={classes.leftSection}>
          <div className={classes.circle}>
            <Typography
              align="center"
              variant="h2"
              classes={{ root: classes.totalDone }}
            >
              <CountUp
                end={this.props.totalDoneActions}
                duration={3}
                start={0}
                delay={0.1}
              />
            </Typography>
            <Typography align="center" classes={{ root: classes.actionLegend }}>
              Actions réalisées
            </Typography>
          </div>
        </div>
        <Typography className={classes.equal}>=</Typography>
        <div className={classes.rightSection}>
          <IconStatRow
            color={Colors.lightBlue}
            stat={this.props.peopleImpacted}
            text={"Personnes impactées par ces actions"}
          >
            <PeopleImpactIcon size={1} />
          </IconStatRow>
          <IconStatRow
            color={Colors.pink}
            stat={this.props.timeSaved}
            text={"Heures économisées"}
          >
            <TimeSavedIcon size={1} />
          </IconStatRow>
          <IconStatRow
            color={Colors.orange}
            stat={this.props.publicSpeakingDone}
            text={"Exercices de prise de parole réalisés"}
          >
            <PublicSpeakingDoneIcon size={1} />
          </IconStatRow>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { isFakeData, fakeData } = state.admin;
  const {
    owner,
    name,
    domain,
    logo,
    allActions,
    createdAt,
    totalDoneActions,
    totalEmployees
  } = isFakeData ? fakeData : state.client;
  const stats = getStats(allActions);

  return {
    allActions,
    ...stats,
    token: state.auth.token,
    createdAt,
    period: "Janvier 2018",
    companyName: "Pulse",
    endRange: "28/01/2018",
    startingRange: "31/12/2017",
    totalDoneActions: isFakeData ? totalDoneActions : allActions.length
  };
};

export default connect(
  mapStateToProps,
  {}
)(withStyles(styles)(TotalDoneActionsSection));
